import { Common } from '../../common';
import {
  CreateValues,
  UpdateValues,
  EditResponse,
  TestPatientPopulated,
} from '../../models/workflowTest/entity/patient';
import _ from 'lodash';

export default class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(): Promise<TestPatientPopulated[]> {
    const url = this.common.constructPath(`/workflow-test/entity/patient`);
    return this.common.getJSON(url);
  }

  async findOneById(ehrInformationId: string): Promise<EditResponse> {
    const url = this.common.constructPath(
      `/workflow-test/entity/patient/${ehrInformationId}`,
    );
    return this.common.getJSON(url);
  }

  async create(values: CreateValues): Promise<EditResponse> {
    const url = this.common.constructPath(`/workflow-test/entity/patient`);
    return this.common.postJSON(url, values);
  }

  async clone(ehrInformationId: string): Promise<EditResponse> {
    const url = this.common.constructPath(
      `/workflow-test/entity/patient/${ehrInformationId}/clone`,
    );
    return this.common.postJSON(url, {});
  }

  async update(ehrInformationId: string, values: UpdateValues): Promise<any> {
    const url = this.common.constructPath(
      `/workflow-test/entity/patient/${ehrInformationId}`,
    );
    values.ehrInformation = _(values.ehrInformation)
      .omit(
        'created',
        'updated',
        'createdByNotableInEhrTimestamp',
        'createdByNotableInEhrReason',
        'lastPatientEhrLoginTimestamp',
      )
      .omitBy(_.isNull)
      .omitBy(_.isUndefined)
      .assign({
        id: values.ehrInformation.id,
        patientId: values.patient?.id ?? values.ehrInformation.patientId ?? '',
      })
      .value();
    if (values.patient) {
      values.patient = _(values.patient)
        .omit('created', 'updated')
        .omitBy(_.isNull)
        .assign({ id: values.patient.id })
        .value();
    }
    return this.common.patchJSON(url, values);
  }
}
